import React, { useState, useEffect } from 'react';
import PhaseCurrentCheckBox from './PhaseCurrentCheckBox';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { ItemComboBox, ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';

export type PhaseCurrentCheckBoxData = {
  isRDisp: boolean; //R相表示
  isSDisp: boolean; //S相表示
  isTDisp: boolean; //T相表示
  isPileup: boolean; //重ね合わせ
  isDCRemoval: boolean; //直流成分除去　DC component removal
  isLowPassNo:number; //ローパスフィルタ
};

const useStyles = makeStyles(
  createStyles({
    tableCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px 0px 0px 4px',
      borderBottomWidth: '0px',
    },
    labelStyle: {
      padding: '5px 0px 0px 10px',
      fontSize: '16px',
    },
    itemBoxStyle: {
      fontSize: '16px',
    },
  })
);

type Props = {
  selectData: PhaseCurrentCheckBoxData;
  onSelectDataChangeEvent: (data: PhaseCurrentCheckBoxData) => void;
};

const PhaseCurrentCheckBoxList: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const tdStyle: React.CSSProperties = {};
  const tableStyle: React.CSSProperties = {
    borderCollapse: `collapse`,
  };
  
  /**
    * ローパスフィルタ切替
    */
  const lowPassList: ComboBoxItemType[] = [
    { index: 0, name: t('PhaseCurrentCheckBoxList.なし', 'なし') },
    { index: 1, name: t('PhaseCurrentCheckBoxList.あり', 'あり') },
  ];

  /**
   * R相チェックボックス変更event
   * @param event 
   */
  const onRCheckBoxChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onRCheckBoxChange ' + event.target.value);
    props.onSelectDataChangeEvent({
      ...props.selectData,
      isRDisp: !props.selectData.isRDisp,
    });
  };
  /**
   * S相チェックボックス変更event
   * @param event 
   */
  const onSCheckBoxChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onSCheckBoxChange ' + event.target.value);
    props.onSelectDataChangeEvent({
      ...props.selectData,
      isSDisp: !props.selectData.isSDisp,
    });
  };
  /**
   * T相チェックボックス変更event
   * @param event 
   */
  const onTCheckBoxChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onTCheckBoxChange ' + event.target.value);
    props.onSelectDataChangeEvent({
      ...props.selectData,
      isTDisp: !props.selectData.isTDisp,
    });    
  };
  /**
   * 重ね合わせ変更event
   * @param event 
   */
  const onPileupChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onPileupChange ' + event.target.value);
    props.onSelectDataChangeEvent({
      ...props.selectData,
      isPileup: !props.selectData.isPileup,
    });    
  };
  /**
   * 直流成分除去変更event
   * @param event 
   */
  const onDCRemovalChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onDCRemovalChange ' + event.target.value);
    props.onSelectDataChangeEvent({
      ...props.selectData,
      isDCRemoval: !props.selectData.isDCRemoval,
    });
  };
  /*
   * ローパスフィルタ有効無効変更event
   */
  const LowPassSelectChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug(['LowPassSelectChange - selectData=', props.selectData]);
    const lowPassNo = Number(event.target.value);
    props.onSelectDataChangeEvent({
      ...props.selectData,
      isLowPassNo: lowPassNo,
    });
  };
   
  return (
    <>
      <div style={{ display: 'flex' }}>
        <table>
          <tr>
            <td style={{ padding: '0px' }}>
              <PhaseCurrentCheckBox
                itemName={t('PhaseCurrentCheckBoxList.R相', 'R相')}
                color={'red'}
                isCheckd={props.selectData.isRDisp}
                onChange={onRCheckBoxChange}
              />
            </td>
            <td style={{ padding: '0px' }}>
              <PhaseCurrentCheckBox
                itemName={t('PhaseCurrentCheckBoxList.S相', 'S相')}
                color={'blue'}
                isCheckd={props.selectData.isSDisp}
                onChange={onSCheckBoxChange}
              />
            </td>
            <td style={{ padding: '0px' }}>
              <PhaseCurrentCheckBox
                itemName={t('PhaseCurrentCheckBoxList.T相', 'T相')}
                color={'green'}
                isCheckd={props.selectData.isTDisp}
                onChange={onTCheckBoxChange}
              />
            </td>
          </tr>
        </table>
        <table>
          <tr>
            <td>
              <input type="checkbox" onChange={onPileupChange} checked={props.selectData.isPileup} />
              {t('PhaseCurrentCheckBoxList.重ね合わせ', '重ね合わせ')}
            </td>
          </tr>
          <tr>
            <td>
              <input type="checkbox" onChange={onDCRemovalChange} checked={props.selectData.isDCRemoval} />
              {t('PhaseCurrentCheckBoxList.直流成分除去', '直流成分除去')}
            </td>
          </tr>
        </table>        
        <div style={{ verticalAlign: 'top' }}>
          <tbody>
            <tr>
              <td>
                {' ' /* スペース調整 */}
              </td>
            </tr>
            <tr>
              <td>
                <ItemComboBox
                  label={t('PhaseCurrentCheckBoxList.ローパスフィルタ', 'ローパスフィルタ：')}
                  itemList={lowPassList}
                  value={props.selectData.isLowPassNo}
                  labelStyle={classes.labelStyle}
                  itemBoxStyle={classes.itemBoxStyle}
                  onChangeEvent={LowPassSelectChange}
                />
              </td>
            </tr>
          </tbody>
        </div>
      </div>
    </>
  );
};

export default PhaseCurrentCheckBoxList;
